const transformObjectValuesToObject = <T extends string>(obj: { [key: string]: T }) =>
  Object.values(obj).reduce<Record<T, null>>(
    (acc, value) => {
      acc[value] = null;

      return acc;
    },
    {} as Record<T, null>,
  );

export { transformObjectValuesToObject };
